import React from 'react';
import { addNode, getNodeId, isAdmin, onNodeSuggestion } from '../../scripts/cy-core';
import GraphButton from '../../../GraphButton';
import SelectingControl from './SelectingControl';
import { setCurrentNode } from '../../scripts/tree-slice';
import { useDispatch } from 'react-redux';
import { NODE_LIMIT } from '../../../../constants/constants';
import ResizeBtn from './ResizeBtn';
import { Space } from 'antd';

const GraphHeader = ({ cy }) => {
  const dispatch = useDispatch();

  const onClickSuggestionCallback = (evt) => {
    const nodeId = getNodeId(evt);
    cy.getElementById(nodeId).emit('tap');
  };

  // Suggestions:
  function onSearchKeyup(e) {
    onNodeSuggestion(e, onClickSuggestionCallback);
    e.stopPropagation();
  }

  const onBtnAddNode = () => {
    const name = $('#keyword').val();
    if (name !== '') {
      if (!isAdmin() && cy.elements('node').length > NODE_LIMIT) {
        alert('Bạn đã đạt giới hạn 50 người trong biểu đồ.');
        return;
      }
      const node = addNode({ name, gender: 'm' });
      dispatch(setCurrentNode(node.data()));
      // autoArrange();
      // refreshSummary();
    }
  };

  return (
    <div id="content-header" style={{ display: 'flex', flexWrap: 'wrap' }}>
      <Space id="search-block" direction="vertical">
        <div id="search-header">
          <div id="searchBox">
            <input
              type="text"
              className="form-control text-height-60 suggestion"
              placeholder="Nhập tên người cần tìm/thêm"
              id="keyword"
              name="keyword"
              onKeyUp={onSearchKeyup}
              onClick={onSearchKeyup}
            />
            <div className="suggestions" />
          </div>

          <div id="header-btn">
            <GraphButton
              label="Thêm"
              onClick={onBtnAddNode}
              title="Thêm một Người mới với tên vừa nhập"
            />
            <input
              id="normalSizeBtn"
              type="submit"
              className="btn btn-primary hide"
              value="Normal"
            />
            <input id="largeSizeBtn" type="submit" className="btn btn-primary hide" value="Large" />
          </div>
        </div>

        <div>
          <div id="selecting-view">
            <span>Đang chọn : </span>
            <span id="selectingNodes" />
          </div>
          <div className="hide">
            <span>Edges : </span>
            <span id="selectingEdges" />
          </div>
        </div>
      </Space>
      <SelectingControl />
      {/* <Space id="control-block" direction="vertical" className="col-lg-8 col-sm-12">
        <ResizeBtn />
        
      </Space> */}
    </div>
  );
};
export default GraphHeader;
